import { createAPI } from '@common'
export default {
  getAppSetting: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0ufobou0dpogjh0bqq', 'GET', config),
  // 保存app端租户配置信息
  postAppSetting: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0ufobou0dpogjh0bqq0tbwf', 'POST', config),
  // 获取pc端租户配置信息
  getWebSetting: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0ufobou0dpogjh0xfc', 'GET', config),
  // 保存pc端租户配置信息
  postWebSetting: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0ufobou0dpogjh0xfc0tbwf', 'POST', config),
  // 保存偏好
  postConfigPreference: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0ufobou0dpogjh0qsfgfsfodf0tbwf', 'POST', config),
  // 查询偏好
  getConfigPreference: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0ufobou0dpogjh0qsfgfsfodf', 'GET', config),
  // 查询偏好
  getHomeTheamConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0ufobou0dpogjh0ipnfqbhf', 'GET', config),
  // 获取多文种配置信息
  getFontFamilySetting: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0ufobou0dpogjh0dibsut', 'GET', config),
  //保存多文种配置信息
  postFontFamilySetting: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0ufobou0dpogjh0dibsut0tbwf', 'POST', config),
  //设置多文种主题
  changeSystemFontFamily: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfst0gpou0tbwf', 'POST', config),
}
